module.exports = __webpack_public_path__ + "img/ilacmra.d1c41e80.png";